import { ACCOUNT_SERVER_HOST, SMS_SERVER_HOST, WMS_SERVER_HOST } from "../../constants/Profile";

// 登录
export const sendAliyunVerifyCode = SMS_SERVER_HOST + "/openAPI/sms/aliyun/verifyCode";
export const authToken = ACCOUNT_SERVER_HOST + "/openAPI/account/auth/token?type=ixuanzhi";
export const getSessionUser = ACCOUNT_SERVER_HOST + "/account/auth/session";
// 微信扫码登录
// export const authTokenWeixin = ACCOUNT_SERVER_HOST + "/openAPI/account/auth/token/weixin?type=ixuanzhi";

// // 解绑
// export const bingOperationApi = ACCOUNT_SERVER_HOST + "/ixuanzhiUser/bingOperation";
// // 修改手机号
// export const changePhoneApi = ACCOUNT_SERVER_HOST + "/ixuanzhiUser/changePhone";
// // 登出
export const logoutApi = ACCOUNT_SERVER_HOST + "/account/auth/token";



//查询登录用户的临时vip   当前生效状态
export const getVipStatusApi =
  WMS_SERVER_HOST + '/homepage/companyAuth/getVipStatus'


// 获取企业认证状态（true:完成认证 flase:未完成认证（也包括之前认证，后来解绑邮箱的）
export const getAuthStatusApi =
  WMS_SERVER_HOST + '/homepage/companyAuth/getAuthStatus'

